import axios from "axios";
import API_BASE_URL from "../../../config/api";

// Definiujemy zmienną API_ENDPOINT
const API_ENDPOINT = `${API_BASE_URL}/importListControl`;
const BASE_URL = API_BASE_URL;

// Funkcja do pobierania nagłówków z tokenem
const getHeaders = async () => {
  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("Token is not available");
  }
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

// Funkcja do resetowania listy
export const resetList = async (id, nrRef, payload) => {
  try {
    const headers = await getHeaders();
    const response = await axios.post(
      `${API_ENDPOINT}/resetListEksport/${id}/${nrRef}`,
      payload,
      { headers },
    );
    return response.data;
  } catch (error) {
    console.error("Error resetting list:", error);
    throw error;
  }
};

export const resetInternalControl = async (id, nrRef, payload) => {
  try {
    const headers = await getHeaders();
    const response = await axios.post(
      `${API_ENDPOINT}/resetInternalControlEksport/${id}/${nrRef}`,
      payload,
      { headers },
    );
    return response.data;
  } catch (error) {
    console.error("Error resetting internal control:", error);
    throw error;
  }
};

// Funkcja do aktualizacji statusu i wstepniePrzygotowane w bazie danych
export const updateStatusWstepnie = async (id, payload) => {
  try {
    const headers = await getHeaders(); // Pobieramy nagłówki
    const response = await axios.put(
      `${API_ENDPOINT}/updateStatusWstepnieWywoz/${id}`, // Używamy zdefiniowanego API_ENDPOINT
      payload, // Przesyłamy dane w żądaniu
      { headers }, // Nagłówki
    );
    return response.data; // Zwracamy odpowiedź z API
  } catch (error) {
    console.error("Error updating status:", error);
    throw error; // Rzucamy błąd, aby mógł być obsłużony w komponencie
  }
};

export const updateStatusPrzygotowane = async (id, payload) => {
  try {
    const headers = await getHeaders(); // Pobieramy nagłówki
    const response = await axios.put(
      `${API_ENDPOINT}/updateStatusPrzygotowaneWywoz/${id}`, // Używamy zdefiniowanego API_ENDPOINT
      payload, // Przesyłamy dane w żądaniu
      { headers }, // Nagłówki
    );
    return response.data; // Zwracamy odpowiedź z API
  } catch (error) {
    console.error("Error updating status:", error);
    throw error; // Rzucamy błąd, aby mógł być obsłużony w komponencie
  }
};

//Pobieranie danych o przywilejach danego uzytkownika
export const fetchUserPrivileges = async (username) => {
  try {
    // Wysyłamy żądanie do API, przekazując `username` jako parametr
    const response = await axios.get(`${API_ENDPOINT}/${username}/privileges`, {
      headers: await getHeaders(),
    });

    // Zakładamy, że API zwraca cały rekord użytkownika, więc wybieramy tylko przywileje
    const {
      internalControl,
      import: importPrivilege,
      export: exportPrivilege,
      warehouseIn,
      warehouseOut,
      activeRefinement,
      passiveRefinement,
      returnImport,
      returnExport,
      importRegisterEntry,
      exportImport,
      timeImport,
      timeEksport,
    } = response.data;

    // Zwracamy tylko dane o przywilejach użytkownika
    return {
      internalControl,
      import: importPrivilege,
      export: exportPrivilege,
      warehouseIn,
      warehouseOut,
      activeRefinement,
      passiveRefinement,
      returnImport,
      returnExport,
      importRegisterEntry,
      exportImport,
      timeImport,
      timeEksport,
    };
  } catch (error) {
    console.error("Error fetching user privileges:", error);
    // Obsługa błędów - możemy zwrócić null lub rzucić wyjątek w zależności od wymagań
    return null;
  }
};

//FUNKJCE POMOCNICZE

export const fetchData = async (id) => {
  try {
    const response = await axios.get(`${BASE_URL}/fetch-wywoz-zwykly/${id}`, {
      headers: await getHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const saveOrUpdateData = async (id, payload) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/saveOrUpdateWywozZwykly/${id}`,
      payload,
      { headers: await getHeaders() },
    );
    return response.data;
  } catch (error) {
    console.error("Failed to save or update data:", error);
    throw error;
  }
};

export const updateZweryfikowanePrzygotowaneDoWyslania = async (
  id,
  payload,
  statusType,
) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/update-przygotowane-zweryfikowane-status-${statusType}/${id}`,
      payload,
      { headers: await getHeaders() },
    );
    return response.data;
  } catch (error) {
    console.error("Failed to update status:", error);
    throw error;
  }
};

export const updatePrzygotowaneZweryfikowane = async (
  id,
  payload,
  statusType,
) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/update-przygotowane-zweryfikowane-${statusType}/${id}`,
      payload,
      { headers: await getHeaders() },
    );
    return response.data;
  } catch (error) {
    console.error("Failed to update status:", error);
    throw error;
  }
};

export const updateStatusDoWeryfikacji = async (id, payload, statusType) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/update-status-${statusType}-weryfikacja/${id}`,
      payload,
      { headers: await getHeaders() },
    );
    return response.data;
  } catch (error) {
    console.error("Failed to update status:", error);
    throw error;
  }
};

export const updateStatusDoWyslania = async (id, payload, statusType) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/update-status-${statusType}-do-wyslania/${id}`,
      payload,
      { headers: await getHeaders() },
    );
    return response.data;
  } catch (error) {
    console.error("Failed to update status:", error);
    throw error;
  }
};

export const updateStatusDoPoprawy = async (id, payload, statusType) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/update-status-${statusType}-do-poprawy/${id}`,
      payload,
      { headers: await getHeaders() },
    );
    return response.data;
  } catch (error) {
    console.error("Failed to update status:", error);
    throw error;
  }
};

export const updatePrzygotowane = async (id, payload, statusType) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/update-status-${statusType}-przygotowane/${id}`,
      payload,
      { headers: await getHeaders() },
    );
    return response.data;
  } catch (error) {
    console.error("Failed to update status:", error);
    throw error;
  }
};

export const saveVerifyingData1 = async (id, payload) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/saveVerifyingData-wywoz-zwykly/${id}`,
      payload,
      { headers: await getHeaders() },
    );
    return response.data;
  } catch (error) {
    console.error("Failed to save verifying data:", error);
    throw error;
  }
};

export const saveComment = async (id, payload) => {
  try {
    const response = await axios.post(`${BASE_URL}/comments/${id}`, payload, {
      headers: await getHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Failed to save comment:", error);
    throw error;
  }
};

export const saveKwComment = async (id, payload) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/kw-comments/${id}`,
      payload,
      {
        headers: await getHeaders(),
      },
    );
    return response.data;
  } catch (error) {
    console.error("Failed to save KW comment:", error);
    throw error;
  }
};

export const fetchKwComments = async (id) => {
  try {
    const response = await axios.get(`${BASE_URL}/kw-comments/${id}`, {
      headers: await getHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch KW comments:", error);
    throw error;
  }
};

export const saveCheckbox = async (id, payload) => {
  try {
    const response = await axios.put(
      `${BASE_URL}/saveCheckbox/${id}`,
      payload,
      { headers: await getHeaders() },
    );
    return response.data;
  } catch (error) {
    console.error("Failed to save checkbox:", error);
    throw error;
  }
};

export const getSADAndDrugaWartosc = async (id) => {
  try {
    const response = await axios.get(`${BASE_URL}/get-SAD-Pik/${id}`, {
      headers: await getHeaders(),
    });
    return {
      SAD: response.data.SAD, // Adjust this based on actual API response
      Plik: response.data.plikiBox, // Adjust this based on actual API response
    };
  } catch (error) {
    console.error("Error fetching SAD and drugaWartosc:", error);
    throw error;
  }
};

export const saveInternalControlDataDates = async (id, payload) => {
  try {
    const response = await axios.put(
      `${BASE_URL}/saveInternalControlDataWywozZwykly/${id}`,
      payload,
      { headers: await getHeaders() },
    );
    return response.data;
  } catch (error) {
    console.error("Failed to save or update data:", error);
    throw error;
  }
};

export const fetchLokalizacjaOdprawList = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/list/urzadZgloszenia`, {
      headers: await getHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching lokalizacja odpraw list:", error);
    throw error;
  }
};

export const fetchLokalizacjaTransportuList = async () => {
  try {
    const response = await axios.get(
      `${BASE_URL}/list/lokalizacjaTransportow`,
      {
        headers: await getHeaders(),
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching lokalizacja transportu list:", error);
    throw error;
  }
};
